import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Pages/Home';
import Productos from './components/Pages/Productos';
import Producto from './components/Pages/Producto';

import { FilterContextProvider } from './context/FilterContext';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <FilterContextProvider>
              <Home />
            </FilterContextProvider>
          }
        />
        <Route
          path="/productos"
          element={
            <FilterContextProvider>
              <Productos />
            </FilterContextProvider>
          }
        />
        <Route
          path="/producto/:id"
          element={
            <FilterContextProvider>
              <Producto />
            </FilterContextProvider>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
